export default __webpack_public_path__ + "static/media/Dairy free-1.37c5f983.svg";